$shm_hitalama_range $mol_view
	min? 0
	max? 10
	step? 1
	value? 0
	unit \
	enabled true
	vertical? false
	attr *
		^
		shm_hitalama_range_vertical <= vertical?
	style *
		^
		width \100%
		height \100%
		minWidth \100%
		minHeight \100%
		position \relative
	Body $rise_range
		min? <=> min?
		max? <=> max?
		step? <=> step?
		value? <=> value?
		unit <= unit
		enabled <= enabled
		style *
			^
			position \absolute
			left \0
			top <= range_top \0
			width <= range_width \100%
			height <= range_height \100%
			transform <= range_transform \
			transformOrigin <= range_transformOrigin \
			translate <= range_translate \
	sub /
		<= Body
